import { jwtDecode } from "jwt-decode";
import { api } from "./api";
import { getToken } from "../services/AuthStorage";
export const getUserProfile = async () => {
  try {
    const response = await api.get("/Users/profile");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserProfile1 = async () => {
  try {
    const response = await api.get("/Users/profile1");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProfile = async (profileData) => {
  try {
    const response = await api.post("/Users/update", {
      userId: profileData.userId,
      phone: profileData.phone,
      address: profileData.address,
      dateOfBirth: profileData.dateOfBirth,
      gender: profileData.gender,
      city: profileData.city,
      district: profileData.district,
      ward: profileData.ward,
      country: profileData.country,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getUserFromToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Error parsing token:", error);
    localStorage.removeItem("token");
    return null;
  }
};

export const getUserLoyaltyInfo = async (userId) => {
  if (!userId) throw new Error("Missing userId for loyalty API");
  const [history, leaderboard] = await Promise.all([
    api.get(`/loyalty/user/${userId}/history`),
    api.get(`/loyalty/leaderboard/top-users`)
  ]);
  return { history: history.data, leaderboard: leaderboard.data };
};
